export default class BaseAudioVisualiser {
    constructor(canvasElement, analysisMetadata) {
        this.canvas = canvasElement;
        this.metadata = analysisMetadata;
    }
    resize(width = 0, height = 0) {
        width = width === 0 ? this.canvas.clientWidth : width;
        height = height === 0 ? this.canvas.clientHeight : height;
        this.canvas.width = width;
        this.canvas.height = height;
    }
    minDim() {
        return Math.min(this.canvas.width, this.canvas.height);
    }
    center() {
        return { x: this.canvas.width / 2, y: this.canvas.height / 2 };
    }
    minDb() {
        return this.metadata.minDb;
    }
    maxDb() {
        return this.metadata.maxDb;
    }
    frequencyBinCount() {
        return this.metadata.frequencyBinCount;
    }
    timeFftSize() {
        return this.metadata.timeFftSize;
    }
}
